import React from 'react'

const Heading = ({ title }) => (
    <div className='heading text-center pt-5 mb-5'>
        <h2 className='mb-3 fw-bolder'> { title } </h2>
        
        <p className='text-secondary'> Lorem, ipsum dolor sit amet consectetur adipisicing elit. </p>
    </div>
)

export default Heading